import { render, staticRenderFns } from "./AiSolution.vue?vue&type=template&id=2cd9031f&scoped=true"
import script from "./AiSolution.vue?vue&type=script&lang=js"
export * from "./AiSolution.vue?vue&type=script&lang=js"
import style0 from "./AiSolution.vue?vue&type=style&index=0&id=2cd9031f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd9031f",
  null
  
)

export default component.exports